import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { camelize } from '../../util/string';
export const ASSET_NAME = 'region-landing-page';
export const ASSET_SUFFIX = '-landing-page';

export const formatRegion = (region) => region.toLowerCase().replace(/ /g, "-");

export const loadData = (params, search) => dispatch => {
  const { region } = params || {};
  const formattedRegion = formatRegion(region);
  const pageAsset = { [`${camelize(formattedRegion)}`]: `content/pages/${formattedRegion}.json` };

  return dispatch(fetchPageAssets(pageAsset, true));
};
